import React, { useState, useEffect } from 'react';
import { Box, Button, TextField, Switch, FormControlLabel, IconButton, CircularProgress, MenuItem, Dialog, DialogContent, InputAdornment, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { closeModal, toggleLoading } from '../../../state/ModalSlice/ModalSlice';
import { useAppSelector } from '../../../state/state';
import { addDoc, collection, Timestamp, updateDoc } from 'firebase/firestore';
import { db, storage } from '../../../Config/firebase';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { RootState, useAppDispatch } from '../../../state/state';
import { } from '@mui/material';
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { GeoPoint } from "firebase/firestore";
import { getGeoHash } from '../utilityFunctions';
import { getLatLong } from '../utilityFunctions';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import InfoIcon from '@mui/icons-material/Info';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
import { toast } from 'react-toastify';
import AttachmentIcon from '@mui/icons-material/Attachment';
import dayjs from 'dayjs';
const GEO_LOC_API = import.meta.env.VITE_GEOLOCATION_API_KEY || process.env.VITE_GEOLOCATION_API_KEY
import { FLAVOR, SECRETS_ENV } from '../../../Config/firebase';
import { useBackend } from '../../../hooks/backend/useBackend';
import { selectBankAccounts, selectEffectiveUID } from '../../../state/UserStatesV2/userSliceV2';
import { setFieldsForEditorJSModal } from '../../../state/ArbitrarySlice/ArbitratySlice';
import { openModal } from '../../../state/ModalSlice/ModalSlice';

interface Ticket {
    ticketDetails: string;
    ticketPrice: string;
    ticketCount: string;
}

interface TicketError {
    ticketDetails: boolean;
    ticketPrice: boolean;
    ticketCount: boolean;
}

// Removed unused Errors interface

enum EventCategory {
    ACTIVITIES = "Activities",
    SPORTS = "Sports",
    CULTURE = "Culture",
    WORKSHOP = "Workshop"
}

export const defaultEventImages = {
    Activities:"https://storage.googleapis.com/flutterflow-io-6f20.appspot.com/projects/saksham-provider-develop-e0dw3z/assets/8b4xhjndxb6g/activity_banner.png",
    Sports:"https://storage.googleapis.com/flutterflow-io-6f20.appspot.com/projects/saksham-provider-develop-e0dw3z/assets/ll3ud7fibl0r/sports_banner.png",
    Culture:"https://storage.googleapis.com/flutterflow-io-6f20.appspot.com/projects/saksham-provider-develop-e0dw3z/assets/tc0kkvqoh6t2/Cultural_banner.jpeg",
    Workshop:"https://storage.googleapis.com/flutterflow-io-6f20.appspot.com/projects/saksham-provider-develop-e0dw3z/assets/l39dryw0blac/workshop_banner.png"
}


const AddEventsModal: React.FC = () => {
    const isOpen = useAppSelector((state: RootState) => state.ModalSlice.AddEventsModalOpen);
    const providerId: string = useAppSelector(selectEffectiveUID)  
    const dispatch = useAppDispatch();

    const today = new Date();
    const thirtyDaysLater = new Date(today.getTime() + 30 * 24 * 60 * 60 * 1000);

    const [formData, setFormData] = useState({
        eName: '',
        eSummary: '',
        contactPhoneNumber: '',
        isOpen: true,
        eCategory: EventCategory.ACTIVITIES,
        eStartTime: new Date(today.setHours(9, 0, 0, 0)),
        eEndTime: new Date(thirtyDaysLater.setHours(17, 0, 0, 0)),
        paymentProfileId: 0,
        eGeoLocation: { hash: "", latlang: new GeoPoint(0, 0) },
        placeName: "",
        placeAddress: "",
        eTermsConditions: "1. All tickets are non-refundable and non-transferable, unless otherwise stated. 2. Attendees must present a valid ticket and identification at the event entrance for admission. 3. The event organizers reserve the right to refuse entry or eject any person who is not in compliance with the event rules and regulations.",
        eRegsStartTime: new Date(today.setHours(9, 0, 0, 0)),
    });
    const BankAccounts = useAppSelector(selectBankAccounts)
    const bankAccountOptions = BankAccounts.map(bankAccount => {
        return (

            bankAccount.iFSC.slice(0, 4) + " - " + bankAccount.accountNo)
    })
    const [errors, setErrors] = useState({
        eName: false,
        eSummary: false,
        eStartTime: false,
        eEndTime: false,
        dateTime: false,
        location: false
    });

    const [image, setImage] = useState<File | null>(null);
    const [imagePreview, setImagePreview] = useState<string | null>(null);
    const [imageSizeExceeded, setImageSizeExceeded] = useState(false);
    const [location, setLocation] = useState<any>(null);
    // Removed unused geoPoint state
    const [paymentProfileID, setPaymentProfileID] = useState<number>(0);
    const [editorDescriptionContent, setEditorDescriptionContent] = useState<any>(null);
    const [editorTermsContent, setEditorTermsContent] = useState<any>(null);

    const [tickets, setTickets] = useState<Ticket[]>([{
        ticketDetails: '',
        ticketPrice: '',
        ticketCount: ''
    }]);


    const [ticketErrors, setTicketErrors] = useState<TicketError[]>([{
        ticketDetails: false,
        ticketPrice: false,
        ticketCount: false
    }]);

    const isLoading = useAppSelector((state: RootState) => state.ModalSlice.isLoading);
    
    useEffect(() => {
        if (location) {
            getLatLong(location.value.place_id).then((geometry: { lat: any, lng: any }) => {
                const geoPoint = new GeoPoint(geometry.lat, geometry.lng);

                setFormData(prev => ({
                    ...prev, eGeoLocation: { hash: geoPoint != null ? getGeoHash(geoPoint) || "" : "", latlang: geoPoint },
                    placeName: location.value.structured_formatting.main_text,
                    placeAddress: location.label
                }));
            })
        }
    }, [location])

    // Listen for editor save events
    useEffect(() => {
        const handleEditorSave = (event: any) => {
            const { content, fieldType, sourceModal } = event.detail;
            
            // Only update if the event is coming from this modal
            if (sourceModal !== 'AddEventsModal') {
                return;
            }
            
            if (fieldType === 'description') {
                setEditorDescriptionContent(content);
                // Convert content to plain text for form submission
                const plainText = content.blocks.map((block: any) => {
                    if (block.type === 'paragraph' || block.type === 'header') {
                        return block.data.text;
                    }
                    return '';
                }).join('\n');
                setFormData(prev => ({ ...prev, eSummary: plainText }));
            } else if (fieldType === 'terms') {
                setEditorTermsContent(content);
                // Convert content to plain text for form submission
                const plainText = content.blocks.map((block: any) => {
                    if (block.type === 'paragraph' || block.type === 'header') {
                        return block.data.text;
                    }
                    return '';
                }).join('\n');
                setFormData(prev => ({ ...prev, eTermsConditions: plainText }));
            }
        };

        window.addEventListener('editorSaveContent', handleEditorSave);
        
        return () => {
            window.removeEventListener('editorSaveContent', handleEditorSave);
        };
    }, []);

    // Handle change functions
    const handleChangeBuzzName = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormData(prev => ({ ...prev, eName: event.target.value }));
        setErrors(prev => ({ ...prev, eName: false }));
    };




    const handleChangeContactPhoneNumber = (event: React.ChangeEvent<HTMLInputElement>) => {
        // Allow only numbers, spaces, hyphens, parentheses, and plus sign
        const phoneRegex = /^[0-9\s\-\(\)\+]*$/;
        if (phoneRegex.test(event.target.value) || event.target.value === '') {
            setFormData(prev => ({ ...prev, contactPhoneNumber: event.target.value }));
        }
    };

    const handleChangeIsLive = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormData(prev => ({ ...prev, isOpen: event.target.checked }));
    };


    const handleChangeCategory = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormData(prev => ({ ...prev, eCategory: event.target.value as EventCategory }));
    };

    const handleChangeStartDate = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newDate = new Date(formData.eStartTime);
        const [year, month, day] = event.target.value.split('-').map(Number);
        newDate.setFullYear(year, month - 1, day);
        setFormData(prev => ({ ...prev, eStartTime: newDate }));
        setErrors(prev => ({ ...prev, eStartTime: false }));
    };

    const handleChangeEndDate = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newDate = new Date(formData.eEndTime);
        const [year, month, day] = event.target.value.split('-').map(Number);
        newDate.setFullYear(year, month - 1, day);
        setFormData(prev => ({ ...prev, eEndTime: newDate }));
        setErrors(prev => ({ ...prev, eEndTime: false }));
    };



    const handleOpenDescriptionEditor = () => {
        dispatch(setFieldsForEditorJSModal({
            content: editorDescriptionContent,
            fieldType: 'description',
            sourceModal: 'AddEventsModal'
        }));
        dispatch(openModal('EditorJSModalOpen'));
    };

    const handleOpenTermsEditor = () => {
        dispatch(setFieldsForEditorJSModal({
            content: editorTermsContent,
            fieldType: 'terms',
            sourceModal: 'AddEventsModal'
        }));
        dispatch(openModal('EditorJSModalOpen'));
    };

    // Helper function to display editor content preview
    const getContentPreview = (content: any, fallbackText: string) => {
        if (!content || !content.blocks || content.blocks.length === 0) {
            return fallbackText;
        }
        
        return content.blocks.map((block: any) => {
            if (block.type === 'paragraph' && block.data.text) {
                return block.data.text;
            } else if (block.type === 'header' && block.data.text) {
                return block.data.text;
            }
            return '';
        }).filter(text => text).join(' ').substring(0, 150) + (content.blocks.some((block: any) => block.data.text && block.data.text.length > 0) ? '...' : '');
    };



    const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files ? event.target.files[0] : null;
        setImageSizeExceeded(false);
        if (file) {
            if (file.size > 5 * 1024 * 1024) {
                setImageSizeExceeded(true);
                return;
            }
            setImage(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result as string);
            };
            reader.readAsDataURL(file);
        }
    };

    const isStartTimeAfterEndTime = (): boolean => {
        return formData.eStartTime >= formData.eEndTime;
    };

    const validateForm = () => {
        let isValid = true;
        const newErrors = { ...errors };
        const newTicketErrors = tickets.map(ticket => ({
            ticketDetails: !ticket.ticketDetails.trim(),
            ticketPrice: !ticket.ticketPrice.trim() || parseFloat(ticket.ticketPrice) < 6,
            ticketCount: !ticket.ticketCount.trim() || Number(ticket.ticketCount) <= 0
        }));

        if (formData.eName.trim() === '') {
            newErrors.eName = true;
            isValid = false;
        }
        if (formData.eSummary.trim() === '') {
            newErrors.eSummary = true;
            isValid = false;
        }

        if (!formData.eStartTime) {
            newErrors.eStartTime = true;
            isValid = false;
        }
        if (!formData.eEndTime) {
            newErrors.eEndTime = true;
            isValid = false;
        }

        if (newTicketErrors.some(error => error.ticketDetails || error.ticketPrice || error.ticketCount)) {
            isValid = false;
        }
        if (isStartTimeAfterEndTime()) {
            newErrors.dateTime = true;
            isValid = false;
        } else {
            newErrors.dateTime = false;
        }
        if (!location) {
            newErrors.location = true;
            isValid = false;
        }
        setErrors(newErrors);
        setTicketErrors(newTicketErrors);
        return isValid;
    };


    const handleChangePaymentProfile = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPaymentProfileID(Number(event.target.value));
    };

    const { axiosPostRequest } = useBackend(``)
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!validateForm()) return;
        dispatch(toggleLoading(true));
        try {
            let imageUrl = '';
            if (image) {
                const storageRef = ref(storage, `events/${providerId}/${image.name}`);
                await uploadBytes(storageRef, image);
                imageUrl = await getDownloadURL(storageRef);
            }

            if(imageUrl===""){
                imageUrl = defaultEventImages[formData.eCategory as keyof typeof defaultEventImages];
            }
            const eventData = {
                ...formData,
                eStartTime: Timestamp.fromDate(formData.eStartTime),
                eEndTime: Timestamp.fromDate(formData.eEndTime),
                tickets: tickets.map(ticket => ({
                    ticketDetails: ticket.ticketDetails,
                    ticketPrice: Number(ticket.ticketPrice),
                    ticketCount: Number(ticket.ticketCount),
                    remainingTicket: Number(ticket.ticketCount)
                })),
                ePromoImage: imageUrl, 
                eStatus: "Active",
                eGeoLocation: {...formData.eGeoLocation,placeName: location==null? "" :location?.value?.structured_formatting?.main_text,address :location==null? "" :location?.label},
                placeName: location==null? "" :location?.value?.structured_formatting?.main_text,
                placeAddress: location==null? "" :location?.label,
                accountId: BankAccounts[paymentProfileID].razorpayAccountId,
                participants: 0,
                createdAt: Timestamp.now(),
                // Save editor content
                editorDescriptionContent: editorDescriptionContent,
                editorTermsContent: editorTermsContent

            };

            

            const eventsCollectionRef = collection(db, 'ServiceProviders', providerId, 'Events');
            const docRef = await addDoc(eventsCollectionRef, eventData);
            const docId = docRef.id;
            
            const response:any = await axiosPostRequest(`${SECRETS_ENV.API_END_POINT}/api/shorten`,
                { longUrl: FLAVOR === "DEVELOPMENT" ?   `https://plundrdev.hosaksham.com/details/${providerId}/event/${docId}`: `https://plundr.besaksham.com/details/${providerId}/event/${docId}` },
            );
         
            await updateDoc(docRef, { eventLink: response.data.shortUrl });
            handleClose();
        } catch (error) {
            console.error("Error adding event:", error);
            toast.error("Failed to add event");
        } finally {
            dispatch(toggleLoading(false));
        }
    };

    const handleClose = () => {
        dispatch(closeModal('AddEventsModalOpen'));
        ResetStates();
    };

    function ResetStates() {
        setFormData({
            eName: '',
            eSummary: '',
            contactPhoneNumber: '',
            isOpen: true,
            eCategory: EventCategory.ACTIVITIES,
            eStartTime: new Date(today.setHours(9, 0, 0, 0)),
            eEndTime: new Date(thirtyDaysLater.setHours(17, 0, 0, 0)),
            eRegsStartTime: new Date(today.setHours(9, 0, 0, 0)),

            paymentProfileId: 0,
            eGeoLocation: { hash: "", latlang: new GeoPoint(0, 0) },
            placeName: "",
            placeAddress: "",
            eTermsConditions: "1. All tickets are non-refundable and non-transferable, unless otherwise stated. 2. Attendees must present a valid ticket and identification at the event entrance for admission. 3. The event organizers reserve the right to refuse entry or eject any person who is not in compliance with the event rules and regulations."
        });
        setImage(null);
        setImagePreview(null);
        setErrors({
            eName: false,
            eSummary: false,

            eStartTime: false,
            eEndTime: false,

            dateTime: false,
            location: false
        });
        setTicketErrors([{
            ticketDetails: false,
            ticketPrice: false,
            ticketCount: false
        }]);
        setLocation(null);
        setEditorDescriptionContent(null);
        setEditorTermsContent(null);
    }



    const handleChangeStartTime = (newValue: any) => {
        if (newValue) {
            const newDate = new Date(formData.eStartTime);
            newDate.setHours(newValue.hour(), newValue.minute());
            setFormData(prev => ({ ...prev, eStartTime: newDate }));
        }
    };

    const handleChangeEndTime = (newValue: any) => {
        if (newValue) {
            const newDate = new Date(formData.eEndTime);
            newDate.setHours(newValue.hour(), newValue.minute());
            setFormData(prev => ({ ...prev, eEndTime: newDate }));
        }
    };

    const handleAddTicket = () => {
        setTickets([...tickets, { ticketDetails: '', ticketPrice: '', ticketCount: '' }]);
        setTicketErrors([...ticketErrors, { ticketDetails: false, ticketPrice: false, ticketCount: false }]);
    };

    const handleRemoveTicket = (index: number) => {
        if (tickets.length > 1) {
            const newTickets = tickets.filter((_, i) => i !== index);
            const newErrors = ticketErrors.filter((_, i) => i !== index);
            setTickets(newTickets);
            setTicketErrors(newErrors);
        }
    };

    const handleTicketChange = (index: number, field: keyof Ticket, value: string) => {
        const newTickets = [...tickets];
        const newErrors = [...ticketErrors];

        if (field === 'ticketPrice') {
            // Allow only numbers and one decimal point
            if (!value) {
                newTickets[index][field] = '';
            } else {
                let decimalCount = 0;
                let isValid = true;

                for (let i = 0; i < value.length; i++) {
                    const char = value[i];
                    if (char >= '0' && char <= '9') {
                        // Valid number, continue
                    } else if (char === '.') {
                        if (decimalCount === 0) {
                            decimalCount++;
                        } else {
                            isValid = false;
                            break;
                        }
                    } else {
                        isValid = false;
                        break;
                    }
                }

                if (isValid) {
                    newTickets[index][field] = value;
                }
            }
        } else if (field === 'ticketCount') {
            // Only allow whole numbers for count
            if (!/^\d*$/.test(value)) return;
            newTickets[index][field] = value;
        } else {
            // Handle ticketDetails (name) field
            newTickets[index][field] = value;
        }

        // Clear error when user types
        newErrors[index] = { ...newErrors[index], [field]: false };

        setTickets(newTickets);
        setTicketErrors(newErrors);
    };

    const handleChangeRegsStartDate = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newDate = new Date(formData.eRegsStartTime);
        const [year, month, day] = event.target.value.split('-').map(Number);
        newDate.setFullYear(year, month - 1, day);
        setFormData(prev => ({ ...prev, eRegsStartTime: newDate }));
    };

    return (
        <Dialog
            sx={{
                padding: 0,
                '& .MuiPaper-root': {
                    borderRadius: '10px',
                },
            }}
            maxWidth="md"
            open={isOpen}
            PaperProps={{
                component: 'div',
            }}
        >
            <DialogContent sx={{ paddingX: "60px", paddingY: "50px" }} className={"bg-white"}>
                <div className={"w-[550px]"}>
                    <div className={"header pb-[20px]"}>
                        <p className={"text-cf_heading font-[600] "}>Create an Event</p>
                    </div>

                    <div className={"absolute right-4 top-4"}>
                        <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </div>

                    <div className={"pt-0"}>
                        <div className={""}>
                            <div className={""}>
                                <Box
                                    component={"div"}
                                    sx={{}}
                                >
                                    <div className="flex flex-col gap-4">
                                        <TextField
                                            label="Event Name*"
                                            value={formData.eName}
                                            onChange={handleChangeBuzzName}
                                            error={errors.eName}
                                            helperText={errors.eName ? "Buzz Name is required" : ""}
                                            fullWidth
                                            size='small'
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderColor: 'grey',
                                                        borderRadius: '10px',
                                                    },
                                                    '&:hover fieldset': {
                                                        borderColor: 'grey',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: 'skyblue',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        fontSize: '14px',
                                                    },
                                                },
                                                fontWeight: 400,
                                                width: '550px',
                                            }}
                                        />


                                        <div className="w-full">
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Event Description*
                                            </label>
                                            <div
                                                onClick={handleOpenDescriptionEditor}
                                                className={`w-full min-h-[80px] p-3 border rounded-lg cursor-pointer hover:border-blue-500 transition-colors ${
                                                    errors.eSummary ? 'border-red-500' : 'border-gray-300'
                                                } ${editorDescriptionContent ? 'text-gray-900' : 'text-gray-500'}`}
                                                style={{ fontSize: '14px' }}
                                            >
                                                {getContentPreview(editorDescriptionContent, 'Click to edit event description with rich text editor...')}
                                            </div>
                                            {errors.eSummary && (
                                                <p className="text-red-500 text-xs mt-1">Description is required</p>
                                            )}
                                        </div>
                                        <div className="flex gap-4">
                                            <TextField
                                                select
                                                label="Category"
                                                value={formData.eCategory}
                                                onChange={handleChangeCategory}
                                                size='small'
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        '& fieldset': {
                                                            borderColor: 'grey',
                                                            borderRadius: '10px',
                                                        },
                                                        '&:hover fieldset': {
                                                            borderColor: 'grey',
                                                        },
                                                        '&.Mui-focused fieldset': {
                                                            borderColor: 'skyblue',
                                                        },
                                                        '& .MuiInputBase-input': {
                                                            fontSize: '14px',
                                                        },
                                                    },
                                                    fontWeight: 400,
                                                    width: '260px',
                                                }}
                                            >
                                                {Object.values(EventCategory).map((category) => (
                                                    <MenuItem key={category} value={category}>
                                                        {category}
                                                    </MenuItem>
                                                ))}
                                            </TextField>

                                            <Tooltip title="This phone number will be shown to users when they try to buy tickets" placement="top">
                                                <TextField
                                                    label="Contact Phone Number"
                                                    value={formData.contactPhoneNumber}
                                                    onChange={handleChangeContactPhoneNumber}
                                                    placeholder="e.g., +91 98765 43210"
                                                    size='small'
                                                    InputProps={{
                                                        startAdornment: <InputAdornment position="start">📞</InputAdornment>,
                                                    }}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            '& fieldset': {
                                                                borderColor: 'grey',
                                                                borderRadius: '10px',
                                                            },
                                                            '&:hover fieldset': {
                                                                borderColor: 'grey',
                                                            },
                                                            '&.Mui-focused fieldset': {
                                                                borderColor: 'skyblue',
                                                            },
                                                            '& .MuiInputBase-input': {
                                                                fontSize: '14px',
                                                            },
                                                        },
                                                        fontWeight: 400,
                                                        width: '260px',
                                                    }}
                                                />
                                            </Tooltip>
                                        </div>

                                        <div className="flex flex-col gap-1">
                                            <div className="flex items-center gap-1">
                                                <p className="text-sm text-gray-600 font-medium">Location*</p>
                                                
                                            </div>
                                            <GooglePlacesAutocomplete
                                                apiKey={GEO_LOC_API || process.env.GEO_LOC_API}
                                                selectProps={{
                                                    placeholder: "Search location",
                                                    onChange: (value) => {
                                                        setLocation(value);
                                                        setErrors(prev => ({ ...prev, location: false }));
                                                    },
                                                    value: location,
                                                    components: {
                                                        DropdownIndicator: () => (
                                                            <div className="px-2">
                                                                <LocationOnIcon fontSize="small" style={{ color: errors.location ? '#EF4444' : '#6B7280' }} />
                                                            </div>
                                                        )
                                                    },
                                                    styles: {
                                                        input: (provided) => ({
                                                            ...provided,
                                                            backgroundColor: 'transparent',
                                                        }),
                                                        option: (provided) => ({
                                                            ...provided,
                                                            backgroundColor: 'transparent',
                                                        }),
                                                        singleValue: (provided) => ({
                                                            ...provided,
                                                            backgroundColor: 'transparent',
                                                        }),
                                                        control: (provided) => ({
                                                            ...provided,
                                                            backgroundColor: 'transparent',
                                                            borderColor: errors.location ? "#EF4444" : "gray",
                                                            boxShadow: 'none',
                                                            '&:hover': {
                                                                borderColor: errors.location ? "#EF4444" : 'black',
                                                            },
                                                            '&:focus': {
                                                                borderColor: errors.location ? "#EF4444" : 'black',
                                                            },
                                                            '&:active': {
                                                                borderColor: errors.location ? "#EF4444" : "black"
                                                            },
                                                            borderRadius: '10px',
                                                            fontSize: '14px'
                                                        }),
                                                        menu: (provided) => ({
                                                            ...provided,
                                                            backgroundColor: 'rgba(255, 255, 255, 1)',
                                                            zIndex: 100,
                                                        }),
                                                        menuPortal: (provided) => ({
                                                            ...provided,
                                                            zIndex: 100,
                                                        }),
                                                    },
                                                }}
                                            />
                                            {location && (
                                                <p className="text-sm text-gray-500 mt-1">
                                                    Selected: {location.label}
                                                </p>
                                            )}
                                            {errors.location && (
                                                    <p className="text-cc_error text-xs font-semibold">Location is required</p>
                                                )}
                                        </div>

                                        {/* Add Tickets Section */}
                                       
                                        <div className="">
                                            <div className="flex items-center justify-between mb-4">
                                                <div className="flex items-center gap-2">
                                                    <h3 className="text-sm text-gray-600 font-medium">Add Tickets</h3>
                                                    <Tooltip title="Add different ticket types with their respective prices and maximum quantities">
                                                        <InfoIcon fontSize="small" className="text-gray-500" />
                                                    </Tooltip>
                                                </div>
                                            </div>

                                            {tickets.map((ticket, index) => (
                                                <div key={index} className="flex items-start gap-4 mb-4">
                                                    <TextField
                                                        label="Ticket Name"
                                                        value={ticket.ticketDetails}
                                                        onChange={(e) => handleTicketChange(index, 'ticketDetails', e.target.value)}
                                                        error={ticketErrors[index]?.ticketDetails}
                                                        helperText={ticketErrors[index]?.ticketDetails ? "Required" : ""}
                                                        size="small"
                                                        sx={{
                                                            '& .MuiOutlinedInput-root': {
                                                                '& fieldset': {
                                                                    borderColor: 'grey',
                                                                    borderRadius: '10px'
                                                                },
                                                                '&:hover fieldset': {
                                                                    borderColor: 'grey',
                                                                },
                                                                '&.Mui-focused fieldset': {
                                                                    borderColor: 'skyblue',
                                                                },
                                                                '& .MuiInputBase-input': {
                                                                    fontSize: '14px',
                                                                },
                                                            },
                                                            width: '250px'
                                                        }}
                                                    />
                                                    <TextField
                                                        label="Price"
                                                        value={ticket.ticketPrice}
                                                        onChange={(e) => handleTicketChange(index, 'ticketPrice', e.target.value)}
                                                        error={ticketErrors[index]?.ticketPrice}
                                                        helperText={ticketErrors[index]?.ticketPrice ? "Minimum ₹6 required" : ""}
                                                        size="small"
                                                        InputProps={{
                                                            startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                                                        }}
                                                        sx={{
                                                            '& .MuiOutlinedInput-root': {
                                                                '& fieldset': {
                                                                    borderColor: 'grey',
                                                                    borderRadius: '10px'
                                                                },
                                                                '&:hover fieldset': {
                                                                    borderColor: 'grey',
                                                                },
                                                                '&.Mui-focused fieldset': {
                                                                    borderColor: 'skyblue',
                                                                },
                                                                '& .MuiInputBase-input': {
                                                                    fontSize: '14px',
                                                                },
                                                            },
                                                            width: '150px'
                                                        }}
                                                    />
                                                    <TextField
                                                        label="Max Seats"
                                                        value={ticket.ticketCount}
                                                        onChange={(e) => handleTicketChange(index, 'ticketCount', e.target.value)}
                                                        error={ticketErrors[index]?.ticketCount}
                                                        helperText={ticketErrors[index]?.ticketCount ? "Required" : ""}
                                                        size="small"
                                                        sx={{
                                                            '& .MuiOutlinedInput-root': {
                                                                '& fieldset': {
                                                                    borderColor: 'grey',
                                                                    borderRadius: '10px'
                                                                },
                                                                '&:hover fieldset': {
                                                                    borderColor: 'grey',
                                                                },
                                                                '&.Mui-focused fieldset': {
                                                                    borderColor: 'skyblue',
                                                                },
                                                                '& .MuiInputBase-input': {
                                                                    fontSize: '14px',
                                                                },
                                                            },
                                                            width: '100px'
                                                        }}
                                                    />
                                                    <div className="flex items-center">
                                                        {index === tickets.length - 1 && (
                                                            <IconButton
                                                                onClick={handleAddTicket}
                                                                size="small"
                                                            >
                                                                <AddIcon />
                                                            </IconButton>
                                                        )}
                                                        {tickets.length > 1 && (
                                                            <IconButton
                                                                onClick={() => handleRemoveTicket(index)}
                                                                size="small"
                                                            >
                                                                <DeleteIcon />
                                                            </IconButton>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        <div className="flex flex-col gap-4">
                                            <div>
                                                <p className="text-sm text-gray-600 font-medium mb-2">Start Date & Time</p>
                                                <div className="flex gap-4">
                                                    <TextField
                                                        type="date"
                                                        value={formData.eStartTime.toISOString().split('T')[0]}
                                                        onChange={handleChangeStartDate}
                                                        error={errors.eStartTime}
                                                        helperText={errors.eStartTime ? "Start Date is required" : ""}
                                                        size='small'
                                                        sx={{
                                                            '& .MuiOutlinedInput-root': {
                                                                '& fieldset': {
                                                                    borderColor: 'grey',
                                                                    borderRadius: '10px',
                                                                },
                                                                '&:hover fieldset': {
                                                                    borderColor: 'grey',
                                                                },
                                                                '&.Mui-focused fieldset': {
                                                                    borderColor: 'skyblue',
                                                                },
                                                                '& .MuiInputBase-input': {
                                                                    fontSize: '14px',
                                                                },
                                                            },
                                                            width: '260px'
                                                        }}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <TimePicker
                                                            value={dayjs(formData.eStartTime)}
                                                            onChange={handleChangeStartTime}
                                                            viewRenderers={{
                                                                hours: renderTimeViewClock,
                                                                minutes: renderTimeViewClock,
                                                            }}
                                                            ampm={true}
                                                            slotProps={{
                                                                textField: {
                                                                    size: 'small',
                                                                    sx: {
                                                                        '& .MuiOutlinedInput-root': {
                                                                            '& fieldset': {
                                                                                borderColor: 'grey',
                                                                                borderRadius: '10px',
                                                                            },
                                                                            '&:hover fieldset': {
                                                                                borderColor: 'grey',
                                                                            },
                                                                            '&.Mui-focused fieldset': {
                                                                                borderColor: 'skyblue',
                                                                            },
                                                                            '& .MuiInputBase-input': {
                                                                                fontSize: '14px',
                                                                            },
                                                                        },
                                                                        width: '260px'
                                                                    }
                                                                }
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                </div>
                                            </div>

                                            <div>
                                                <p className="text-sm text-gray-600 font-medium mb-2">End Date & Time</p>
                                                <div className="flex gap-4">
                                                    <TextField
                                                        type="date"
                                                        value={formData.eEndTime.toISOString().split('T')[0]}
                                                        onChange={handleChangeEndDate}
                                                        error={errors.eEndTime}
                                                        helperText={errors.eEndTime ? "End Date is required" : ""}
                                                        size='small'
                                                        sx={{
                                                            '& .MuiOutlinedInput-root': {
                                                                '& fieldset': {
                                                                    borderColor: 'grey',
                                                                    borderRadius: '10px',
                                                                },
                                                                '&:hover fieldset': {
                                                                    borderColor: 'grey',
                                                                },
                                                                '&.Mui-focused fieldset': {
                                                                    borderColor: 'skyblue',
                                                                },
                                                                '& .MuiInputBase-input': {
                                                                    fontSize: '14px',
                                                                },
                                                            },
                                                            width: '260px'
                                                        }}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <TimePicker
                                                            value={dayjs(formData.eEndTime)}
                                                            onChange={handleChangeEndTime}
                                                            viewRenderers={{
                                                                hours: renderTimeViewClock,
                                                                minutes: renderTimeViewClock,
                                                            }}
                                                            ampm={true}
                                                            slotProps={{
                                                                textField: {
                                                                    size: 'small',
                                                                    sx: {
                                                                        '& .MuiOutlinedInput-root': {
                                                                            '& fieldset': {
                                                                                borderColor: 'grey',
                                                                                borderRadius: '10px',
                                                                            },
                                                                            '&:hover fieldset': {
                                                                                borderColor: 'grey',
                                                                            },
                                                                            '&.Mui-focused fieldset': {
                                                                                borderColor: 'skyblue',
                                                                            },
                                                                            '& .MuiInputBase-input': {
                                                                                fontSize: '14px',
                                                                            },
                                                                        },
                                                                        width: '260px'
                                                                    }
                                                                }
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                </div>
                                            </div>
                                            {errors.dateTime && (
                                                <p className="text-red-500 text-sm">End date and time cannot be earlier than start date and time</p>
                                            )}
                                        </div>


                                        <div>
                                            <p className="text-sm text-gray-600 font-medium mb-2">Registration Start</p>
                                            <div className="flex gap-4 items-center">
                                                <TextField
                                                    type="date"
                                                    value={formData.eRegsStartTime.toISOString().split('T')[0]}
                                                    onChange={handleChangeRegsStartDate}
                                                    size='small'
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            '& fieldset': {
                                                                borderColor: 'grey',
                                                                borderRadius: '10px',
                                                            },
                                                            '&:hover fieldset': {
                                                                borderColor: 'grey',
                                                            },
                                                            '&.Mui-focused fieldset': {
                                                                borderColor: 'skyblue',
                                                            },
                                                            '& .MuiInputBase-input': {
                                                                fontSize: '14px',
                                                            },
                                                        },
                                                        width: '260px'
                                                    }}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={formData.isOpen}
                                                            onChange={handleChangeIsLive}
                                                        />
                                                    }
                                                    label="Is Registration Open?"
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <Button
                                                variant="outlined"
                                                component="label"
                                                fullWidth
                                                sx={{
                                                    mb: 0,
                                                    borderRadius: '8px',
                                                    textTransform: 'none',
                                                    color: '#1D4ED8',
                                                    borderColor: '#1D4ED8',
                                                    '&:hover': {
                                                        backgroundColor: '#1D4ED8', color: "#FFFFFF"
                                                    },
                                                }}
                                            >
                                                <span className={"mr-1 flex justify-center items-center"}><AttachmentIcon fontSize='small' /> </span> Click here to upload Events Display Image
                                                <input
                                                    type="file"
                                                    accept="image/jpeg, image/png"
                                                    hidden
                                                    onChange={handleImageChange}
                                                />
                                            </Button>
                                        </div>
                                        {imageSizeExceeded && (
                                            <p style={{ color: 'red' }}>Image size should not exceed 5MB</p>
                                        )}
                                        {imagePreview && (
                                            <Box sx={{ mb: 2, position: 'relative', width: 100, height: 100 }}>
                                                <img src={imagePreview} alt="Logo preview"
                                                    style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }} />
                                                <IconButton
                                                    onClick={() => {
                                                        setImage(null);
                                                        setImagePreview(null);
                                                    }}
                                                    sx={{ position: 'absolute', top: 4, right: 4, bgcolor: 'background.paper' }}
                                                >
                                                    <CloseIcon />
                                                </IconButton>
                                            </Box>
                                        )}

                                        <TextField
                                            size={"small"}
                                            id="Bank Account"
                                            select
                                            label="Bank account"
                                            value={paymentProfileID}
                                            onChange={handleChangePaymentProfile}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderColor: 'grey',
                                                        borderRadius: '10px',
                                                    },
                                                    '&:hover fieldset': {
                                                        borderColor: 'grey',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: 'skyblue',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        fontSize: '14px',
                                                    },
                                                },
                                                fontWeight: 400,
                                                width: '550px',
                                            }}
                                        >
                                            {/* Assuming you have a way to get bank account options */}
                                            {bankAccountOptions.length > 0 ? bankAccountOptions.map((option, index) => (
                                                <MenuItem key={index} value={index}>
                                                    {option}
                                                </MenuItem>
                                            )) : <MenuItem key="0" value={0}>No account Found</MenuItem>}
                                        </TextField>

                                        <div className="w-full">
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Terms and Conditions (Optional)
                                            </label>
                                            <div
                                                onClick={handleOpenTermsEditor}
                                                className={`w-full min-h-[100px] p-3 border border-gray-300 rounded-lg cursor-pointer hover:border-blue-500 transition-colors ${
                                                    editorTermsContent ? 'text-gray-900' : 'text-gray-500'
                                                }`}
                                                style={{ fontSize: '14px' }}
                                            >
                                                {getContentPreview(editorTermsContent, 'Click to edit terms and conditions with rich text editor...')}
                                            </div>
                                        </div>

                                        <div className={"flex gap-2 pt-4"}>
                                            <button
                                                disabled={isLoading}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleClose();
                                                }}
                                                className={`w-full bg-cc_bg-tertiary border border-solid border-gray-500 p-1.5 rounded-lg ${isLoading ? "cursor-not-allowed" : "cursor-pointer"}`}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                onClick={handleSubmit}
                                                disabled={isLoading}
                                                className={`w-full bg-cc_brand text-white p-1.5 rounded-lg border-gray-500 flex justify-center items-center ${isLoading ? "cursor-not-allowed" : "cursor-pointer"}`}
                                            >
                                                {isLoading && <CircularProgress sx={{ color: "white" }} size={20} />}
                                                <p className={"ml-2"}>{isLoading ? "Loading" : "Create Event"}</p>
                                            </button>
                                        </div>
                                    </div>
                                </Box>
                            </div>
                        </div>
                    </div>
                </div>


            </DialogContent>
        </Dialog>
    );
};

export default AddEventsModal;